import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const XMatrix = ({ animate = true }) => (
  <svg viewBox="0 0 600 600" fill="none" className="w-full h-auto" aria-hidden="true">
    <defs>
      <filter id="xglow" x="-60%" y="-60%" width="220%" height="220%">
        <feGaussianBlur stdDeviation="9" result="b" />
        <feMerge>
          <feMergeNode in="b" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <linearGradient id="xgrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#00F0FF" />
        <stop offset="100%" stopColor="#8A2BE2" />
      </linearGradient>
    </defs>

    {[...Array(7)].map((_, i) => (
      <line key={`v${i}`} x1={i * 100} y1="0" x2={i * 100} y2="600" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
    ))}
    {[...Array(7)].map((_, i) => (
      <line key={`h${i}`} x1="0" y1={i * 100} x2="600" y2={i * 100} stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
    ))}

    <motion.line x1="10" y1="10" x2="248" y2="248" stroke="rgba(0,240,255,0.28)" strokeWidth="1" strokeDasharray="3 9" initial={{ pathLength: 0 }} animate={animate ? { pathLength: 1 } : {}} transition={{ duration: 1.6, delay: 0.9, ease: EASE }} />
    <motion.line x1="590" y1="10" x2="352" y2="248" stroke="rgba(0,240,255,0.28)" strokeWidth="1" strokeDasharray="3 9" initial={{ pathLength: 0 }} animate={animate ? { pathLength: 1 } : {}} transition={{ duration: 1.6, delay: 1.0, ease: EASE }} />
    <motion.line x1="10" y1="590" x2="248" y2="352" stroke="rgba(138,43,226,0.32)" strokeWidth="1" strokeDasharray="3 9" initial={{ pathLength: 0 }} animate={animate ? { pathLength: 1 } : {}} transition={{ duration: 1.6, delay: 1.1, ease: EASE }} />
    <motion.line x1="590" y1="590" x2="352" y2="352" stroke="rgba(138,43,226,0.32)" strokeWidth="1" strokeDasharray="3 9" initial={{ pathLength: 0 }} animate={animate ? { pathLength: 1 } : {}} transition={{ duration: 1.6, delay: 1.2, ease: EASE }} />

    <motion.line x1="130" y1="130" x2="470" y2="470" stroke="url(#xgrad)" strokeWidth="24" strokeLinecap="square" filter="url(#xglow)" initial={{ pathLength: 0 }} animate={animate ? { pathLength: 1 } : {}} transition={{ duration: 1.1, delay: 0.45, ease: EASE }} />
    <motion.line x1="470" y1="130" x2="130" y2="470" stroke="url(#xgrad)" strokeWidth="24" strokeLinecap="square" filter="url(#xglow)" initial={{ pathLength: 0 }} animate={animate ? { pathLength: 1 } : {}} transition={{ duration: 1.1, delay: 0.7, ease: EASE }} />

    <motion.circle cx="300" cy="300" r="9" fill="#00F0FF" filter="url(#xglow)" style={{ transformBox: "fill-box", transformOrigin: "center" }} initial={{ scale: 0 }} animate={animate ? { scale: [0, 1.4, 1] } : {}} transition={{ delay: 1.7, duration: 0.7, ease: EASE }} />
    <motion.circle cx="300" cy="300" r="22" stroke="rgba(0,240,255,0.45)" strokeWidth="1.5" fill="none" style={{ transformBox: "fill-box", transformOrigin: "center" }} initial={{ opacity: 0, scale: 0.6 }} animate={animate ? { opacity: [0, 0.9, 0], scale: [0.6, 1.9] } : {}} transition={{ delay: 1.9, duration: 2.6, repeat: Infinity, ease: "easeOut" }} />

    <circle cx="10" cy="10" r="4" fill="#00F0FF" opacity="0.8" />
    <circle cx="590" cy="10" r="4" fill="#00F0FF" opacity="0.8" />
    <circle cx="10" cy="590" r="4" fill="#8A2BE2" opacity="0.8" />
    <circle cx="590" cy="590" r="4" fill="#8A2BE2" opacity="0.8" />
  </svg>
);
